import rnHttp from 'rhino/src/core/http/http.module';
import { default as RsrService, moduleName as RsrServiceName } from "./rsr_service.service.js";

export default angular.module('RsrService', [
  rnHttp
]).factory(RsrServiceName, RsrService)
  .name;
